import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const UploadIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4.82a6.23 6.23 0 0 1 6.13 4.97A4.13 4.13 0 0 1 22 13.9a4.14 4.14 0 0 1-4.17 4.1H7c-2.76 0-5-2.2-5-4.93a4.96 4.96 0 0 1 4.46-4.91A6.26 6.26 0 0 1 12 4.82ZM13 14v-2h2l-3-3-3 3h2v2a1 1 0 0 0 2 0Z" />
    </SvgIcon>
);
